<!--suppress CssUnknownTarget, CssUnknownTarget -->
<template>
  <div>
    <nav-bar></nav-bar>
    <main class="mdc-toolbar-fixed-adjust">
      <div class="mdc-layout-grid app-grid">
        <router-view></router-view>
      </div>
    </main>
  </div>
</template>

<script>
  import NavBar from '@/components/Navbar'

  export default {
    components: {
      NavBar
    }
  }
</script>

<style lang="scss">

  @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700');
  @import url('https://fonts.googleapis.com/icon?family=Material+Icons');

  $mdc-theme-primary: #5495ff;
  $mdc-theme-accent: #b71c1c;
  $mdc-theme-background: #fff;

  @import '~@material/typography/mdc-typography';
  @import '~@material/elevation/mdc-elevation';
  @import '~@material/theme/mdc-theme';
  @import '~@material/layout-grid/mdc-layout-grid';
  @import '~@material/animation/mdc-animation';
  @import '~@material/button/mdc-button';
  @import '~@material/list/mdc-list';

  body {
    padding: 0;
    margin: 0;
  }

  .app-grid {
    --mdc-layout-grid-margin-desktop: 40px;
    --mdc-layout-grid-gutter-tablet: 16px;
    --mdc-layout-grid-gutter-phone: 8px;
  }

</style>



// WEBPACK FOOTER //
// App.vue?a3aff7aa